module.exports = __webpack_public_path__ + "img/image-labels-3-d-desktop.7c10306e.png";